function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import { Icon } from "@blueprintjs/core";
export default function AdvancedOptions(_ref) {
  var children = _ref.children,
      content = _ref.content,
      label = _ref.label,
      style = _ref.style,
      isOpenByDefault = _ref.isOpenByDefault;

  var _useState = useState(isOpenByDefault),
      isOpen = _useState[0],
      setOpen = _useState[1];

  if (!(content || children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    style: _extends({
      marginTop: 5
    }, style)
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setOpen(!isOpen);
    },
    style: {
      cursor: "pointer",
      display: "flex",
      alignItems: "flex-end"
    },
    className: "tg-toggle-advanced-options"
  }, label || "Advanced", " ", /*#__PURE__*/React.createElement(Icon, {
    icon: isOpen ? "caret-down" : "caret-right",
    style: {
      marginLeft: 5
    }
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10
    }
  }, content || children));
}